module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('colgroup', [(_vm.canDestroy) ? _c('col', {
    attrs: {
      "width": "10"
    }
  }) : _vm._e(), _vm._v(" "), _c('col', {
    staticClass: "col-45"
  }), _vm._v(" "), _c('col', {
    staticClass: "col-20"
  }), _vm._v(" "), _c('col', {
    staticClass: "col-10"
  }), _vm._v(" "), _c('col', {
    staticClass: "col-15"
  }), _vm._v(" "), (_vm.securityEnabled) ? _c('col', {
    staticClass: "col-10"
  }) : _vm._e()]), _vm._v(" "), _c('thead', [_c('tr', [(_vm.canDestroy) ? _c('th') : _vm._e(), _vm._v(" "), _c('th', [_vm._v("Tag")]), _vm._v(" "), _c('th', [_vm._v("Author")]), _vm._v(" "), _c('th', [_vm._v("Image")]), _vm._v(" "), _c('th', [_vm._v("Pushed at")]), _vm._v(" "), (_vm.securityEnabled) ? _c('th', [_vm._v("Security")]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredTags), function(tag) {
    return _c('tag-row', {
      key: tag[0].digest,
      attrs: {
        "tag": tag,
        "can-destroy": _vm.canDestroy,
        "security-enabled": _vm.securityEnabled,
        "state": _vm.state
      }
    })
  }))]), _vm._v(" "), _c('table-pagination', {
    attrs: {
      "total": _vm.tags.length,
      "current-page": _vm.currentPage,
      "itens-per-page": _vm.limit
    },
    on: {
      "update:total": function($event) {
        _vm.tags.length = $event
      },
      "update:itensPerPage": function($event) {
        _vm.limit = $event
      },
      "update": _vm.updateCurrentPage
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /home/abuild/rpmbuild/BUILD/Portus-v2.3/~/vue-loader/lib/template-compiler?{"id":"data-v-22137d6b"}!/home/abuild/rpmbuild/BUILD/Portus-v2.3/~/vue-loader/lib/selector.js?type=template&index=0!./modules/repositories/components/tags-table.vue
// module id = 359
// module chunks = 0